module.exports = __webpack_public_path__ + "static/img/bill@2x.8812872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/bill@2x.png
// module id = 5mMo
// module chunks = 70